import { render, staticRenderFns } from "./received-order-stock-reserve-change.vue?vue&type=template&id=7737f575&scoped=true&"
import script from "./received-order-stock-reserve-change.vue?vue&type=script&lang=js&"
export * from "./received-order-stock-reserve-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7737f575",
  null
  
)

export default component.exports